import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({
    endPoint: 'Family/GetAll',
    method: 'GET',
    body: null,
    token: token
  })
}
